import { COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_KEYS } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { NavItemEnum } from '../../../constants/routing/NavItems';
import { useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { useCurrentNavItem } from '../../../hooks/useCurrentNavItem';
import { usePerMonthPricesForRecurringTerms, useProductPromotionIds } from '../pricing/useGrowthPurchaseOptions';
const PROFESSIONAL_API_NAME = 'commerce-hub-professional';
const ENTERPRISE_API_NAME = 'commerce-hub-enterprise';
export const useCommerceHubEarlyAdopterBanner = () => {
  const currentNavItem = useCurrentNavItem();
  const isCommerceRoute = currentNavItem === NavItemEnum.COMMERCE;
  const {
    annualPrice: professionalAnnualPrice,
    annualListPrice: professionalNonDiscountedPrice,
    loading: professionalLoading,
    error: professionalError
  } = usePerMonthPricesForRecurringTerms({
    productApiName: PROFESSIONAL_API_NAME
  });
  const {
    annualPrice: enterpriseAnnualPrice,
    annualListPrice: enterpriseNonDiscountedPrice,
    loading: enterpriseLoading,
    error: enterpriseError
  } = usePerMonthPricesForRecurringTerms({
    productApiName: ENTERPRISE_API_NAME
  });
  const displayedCurrencyCode = useDisplayedCurrencyCode();
  const {
    promotionIds: professionalPromotionIds,
    loading: professionalPromotionsLoading
  } = useProductPromotionIds({
    productApiName: PROFESSIONAL_API_NAME
  });
  const {
    promotionIds: enterprisePromotionIds,
    loading: enterprisePromotionsLoading
  } = useProductPromotionIds({
    productApiName: ENTERPRISE_API_NAME
  });
  const isEligibleForPromotion = (professionalPromotionIds === null || professionalPromotionIds === void 0 ? void 0 : professionalPromotionIds.some(promotionId => COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_KEYS.includes(promotionId))) && (enterprisePromotionIds === null || enterprisePromotionIds === void 0 ? void 0 : enterprisePromotionIds.some(promotionId => COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_KEYS.includes(promotionId)));
  const loading = professionalLoading || enterpriseLoading || professionalPromotionsLoading || enterprisePromotionsLoading;
  const error = professionalError || enterpriseError;
  const shouldShowBanner = Boolean(isCommerceRoute && !loading && !error && isEligibleForPromotion && professionalAnnualPrice && enterpriseAnnualPrice && professionalNonDiscountedPrice && enterpriseNonDiscountedPrice);
  return {
    shouldShowBanner,
    professionalPrice: professionalAnnualPrice,
    enterprisePrice: enterpriseAnnualPrice,
    professionalNonDiscountedPrice,
    enterpriseNonDiscountedPrice,
    currencyCode: displayedCurrencyCode,
    error
  };
};